import React, { useState } from 'react';
import { Eye, EyeOff, Lock, Mail } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import logoImg from '../../logo.png';

export default function Login() {
  const { login, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Заполните все поля');
      return;
    }
    const result = await login(email, password);
    if (!result.success) {
      setError(result.error || 'Неверный email или пароль');
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 40%, #0F172A 100%)',
      padding: 20,
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Decorative gradient orbs */}
      <div style={{
        position: 'absolute', top: '-20%', right: '-10%',
        width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,206,238,0.12) 0%, transparent 70%)',
        filter: 'blur(40px)',
      }} />
      <div style={{
        position: 'absolute', bottom: '-20%', left: '-10%',
        width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,153,149,0.1) 0%, transparent 70%)',
        filter: 'blur(40px)',
      }} />

      {/* Grid pattern */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.03,
        backgroundImage: 'radial-gradient(circle at 1px 1px, #00CEEE 0.5px, transparent 0)',
        backgroundSize: '32px 32px',
      }} />

      <div style={{
        position: 'relative', background: '#fff',
        borderRadius: 24, padding: '44px 40px',
        width: '100%', maxWidth: 420,
        boxShadow: '0 30px 80px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.08)',
        animation: 'slideUp 0.4s ease',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ marginBottom: 16 }}>
            <img src={logoImg} alt="PDA Logo" style={{ height: 52, objectFit: 'contain' }} />
          </div>
          <p style={{ color: '#94A3B8', fontSize: 14, fontWeight: 500 }}>Control Panel Administration</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <Input
            label="Email" type="email" value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="admin@pda.uz" required
            icon={<Mail size={15} />}
          />

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#334155' }}>
              Пароль <span style={{ color: '#EF4444' }}>*</span>
            </label>
            <div style={{ position: 'relative' }}>
              <span style={{
                position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
                color: '#94A3B8', display: 'flex', pointerEvents: 'none',
              }}>
                <Lock size={15} />
              </span>
              <input
                type={showPass ? 'text' : 'password'}
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Введите пароль"
                style={{
                  width: '100%', padding: '10px 42px 10px 38px',
                  border: '1.5px solid #E2E8F0', borderRadius: 10, fontSize: 13,
                  color: '#0F172A', background: '#fff', outline: 'none', fontFamily: 'inherit',
                  transition: 'border-color 0.2s, box-shadow 0.2s',
                }}
                onFocus={e => { e.target.style.borderColor = '#00CEEE'; e.target.style.boxShadow = '0 0 0 3px rgba(0,206,238,0.1)'; }}
                onBlur={e => { e.target.style.borderColor = '#E2E8F0'; e.target.style.boxShadow = 'none'; }}
              />
              <button type="button" onClick={() => setShowPass(v => !v)} style={{
                position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer', color: '#94A3B8',
                display: 'flex', padding: 2, borderRadius: 4,
              }}>
                {showPass ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>

          {error && (
            <div style={{
              padding: '12px 16px', background: '#FEF2F2', borderRadius: 10,
              fontSize: 13, color: '#DC2626', fontWeight: 500,
              borderLeft: '3px solid #EF4444',
              display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <span style={{ flexShrink: 0 }}>!</span>
              {error}
            </div>
          )}

          <Button type="submit" size="lg" disabled={loading} fullWidth style={{
            marginTop: 6, height: 46, fontSize: 14,
          }}>
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{
                  width: 16, height: 16, borderRadius: '50%',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderTopColor: '#fff',
                  animation: 'spin 0.6s linear infinite',
                }} />
                Вход...
              </span>
            ) : 'Войти в систему'}
          </Button>
        </form>

        <div style={{
          marginTop: 24, textAlign: 'center', fontSize: 12, color: '#CBD5E1',
        }}>
          PDA &middot; Mittivoy Group
        </div>
      </div>
    </div>
  );
}
